import {useState, useRef} from "react";
import "./style.scss";
import {Link, useNavigate} from "react-router-dom";
import {CSSTransition} from "react-transition-group";
import "bootstrap/dist/css/bootstrap.min.css";
import {INSTAGRAM, FACEBOOK} from "../../social";

const Navbar = () => {
    const nodeRef = useRef(null);
    const [nav, setNav] = useState(false);
    const navigate = useNavigate();
    const scrollTop = () => setTimeout(() => window.scrollTo(0, 0), 200);

    return <div className="navbar-wrapper">
        <CSSTransition
            in={window.innerWidth > 768 ? true : nav}
            nodeRef={nodeRef}
            timeout={100}
            classNames="alert"
            unmountOnExit
        >
            <div className="nav-list">
                <div ref={nodeRef} className="sloy-mobile">
                    <div onClick={() => {
                    }} className="nav-item-hide">
                        <img onClick={() => setNav(false)} src="./images/close.webp" alt="close-menu"/>
                    </div>

                    <Link to="/how-it-works" onClick={scrollTop} className="nav-item seo-link">How it works?</Link>
                    <Link to="/for-individuals" onClick={scrollTop} className="nav-item seo-link">For individuals</Link>
                    <div className="nav-item">
                        For businesses
                        <div className="submenu">
                            <Link to="/auto-dealerships" onClick={scrollTop} className="name seo-link">Auto Dealerships</Link>
                            <Link to="/auto-auctions" onClick={scrollTop} className="name seo-link">Auto auctions</Link>
                            <Link to="/rental-car-companies" onClick={scrollTop} className="name seo-link">Car rental
                                companies
                            </Link>
                        </div>
                    </div>

                    <div className="nav-item">
                        Why us
                        <div className="submenu">
                            <Link to="/reviews" onClick={scrollTop} className="name seo-link">Reviews</Link>
                            <Link to="/about-us" onClick={scrollTop} className="name seo-link">About us</Link>
                            <Link to="/our-team" onClick={scrollTop} className="name seo-link">Our team</Link>
                        </div>
                    </div>

                    <div className="nav-item">
                        Contact
                        <div className="submenu-contact">
                            <Link to="/carrier" onClick={scrollTop} className="name seo-link">Carrier</Link>
                            <Link to="/customer" onClick={scrollTop} className="name seo-link">Customer</Link>
                        </div>
                    </div>

                    <Link to="/get-quote" onClick={scrollTop} className="driver_btn seo-link">
                        Get a quote
                    </Link>
                </div>
            </div>
        </CSSTransition>
        
        <div className="mobile-left-side">
            <div className="logo">
                <img onClick={()=> navigate("/")} src="./images/logo.webp" alt="leader-auto-ship-logo"/>
            </div>
            
            <div className="icons-social-media">
                <a target="_blank" rel="noopener noreferrer" href={INSTAGRAM}>
                    <img src="./images/Instagram.webp" alt="instagram" loading="lazy"/>
                </a>

                {FACEBOOK && <a target="_blank" rel="noopener noreferrer" href={FACEBOOK}>
                    <img src="./images/Facebook.webp" alt="facebook" loading="lazy"/>
                </a>}
            </div>

            <Link to="/get-quote" onClick={scrollTop} className="driver_btn seo-link">
                Get a quote
            </Link>

            <div className="nav-show">
                <img onClick={() => {
                    setNav(true)
                }} src="./images/menu_hamburger.webp" alt=""/>
            </div>
        </div>
    </div>
}
export default Navbar